<script setup lang="ts">
import { useCaseRouteParams } from "@/hooks/use-case-route-params";

import CheckSCC125 from "./_CheckSCC125.vue";

import type { Metadata } from "@/models/Metadata";
import type { ScorePointData } from "@/models/Point";

defineProps<{
  file: Metadata;
  positive: number;
  negative: number;
  connotation: ScorePointData["scoreConnotation"];
}>();

const routeParams = useCaseRouteParams();
</script>

<template>
  <td aria-hidden="true" />
  <td>
    <router-link
      class="check-score-row tw-inline-block tw-w-full tw-px-2 tw-py-1.5"
      :to="{
        name: 'casefile',
        params: { brand: routeParams.brand, casename: routeParams.casename, casefile: file.fileReference },
      }"
    >
      {{ file.aiClassification ?? "Unknown" }}: {{ file.displayName }}
    </router-link>
  </td>
  <td>
    <CheckSCC125 type="record" :positive="positive" :negative="negative" :connotation="connotation" />
  </td>
  <td />
</template>
